import 'hammerjs';
import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ConfigProvider } from '@mydocma/common';
import { MYDOCMASETTINGS } from '@mydocma/core';
import { APP_CONTAINER_SETTINGS } from '@mydocma/app-container';
import { AUTHSETTINGS, AUTHSTORAGE } from '@mydocma/auth';
import { MatTooltipDefaultOptions, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { IReportConfig } from 'projects/mydocma-rp/src/lib/rp-common/project/project.interface';
import { TASK_CONFIG, WEBSOCKET_CONFIG as MYDOCMA_WEBSOCKET_CONFIG } from '@mydocma/task';
import { PIX_CONFIG, PIX_SETTINGS } from '@mydocma/pix-common';
import { LOGGER_CONFIG } from '@mydocma/common/src/lib/logger';
import { BP_CONFIG } from '@mydocma/co/src/lib/common';

if (environment.production) {
  enableProdMode();
}

export const matTooltipCustomConfig: MatTooltipDefaultOptions = {
  showDelay: 5,
  hideDelay: 5,
  touchendHideDelay: 5,
};

async function main() {

  try {
    const configProvider = new ConfigProvider<IReportConfig>(null);
    const config = await configProvider.loadConfigAsync();

    await platformBrowserDynamic([
      //we could do it here or in app-module
      { provide: LOGGER_CONFIG, useValue: config},
      { provide: AUTHSETTINGS, useValue: config.authConfig },
      { provide: AUTHSTORAGE, useValue: sessionStorage },
      { provide: MYDOCMASETTINGS, useValue: config.mydocmaConfig },


      { provide: APP_CONTAINER_SETTINGS, useValue: config.appContainerConfig },
      { provide: "ReportSettings", useValue: config.reportConfig },

      { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: matTooltipCustomConfig },
      { provide: TASK_CONFIG, useValue: config.taskConfig },
      { provide: "SettingsConfig", useValue: config.settingsConfig },
      { provide: MYDOCMA_WEBSOCKET_CONFIG, useValue: config.webSocketConfig },
      { provide: PIX_CONFIG, useValue: config.pixConfig },
      { provide: PIX_SETTINGS, useValue: config.pixConfig },
      {provide: BP_CONFIG, useValue: {apiUrl: config.bimConfig.bpApiUrl, parentApp: config.appName}}

    ]).bootstrapModule(
      AppModule,
     { ngZoneEventCoalescing: true, ngZoneRunCoalescing: true }).then(() => {
      /*if ('serviceWorker' in navigator && environment.production) {
        navigator.serviceWorker.register('ngsw-worker.js');
      }*/
    })
  } catch (error) {
    console.error(error);
  }
}

main()
